<template>
  <div class="flex flex-direction align-center">
    <div
      v-if="userBase == null"
      class="bg-color-ef flex justify-center"
      style="width: 100%"
    >
      <div
        class="
          flex-row-reverse
          font-color-ae font-size-14
          align-center
          width
          padding-l-r-15
        "
        style="height: 0.34rem"
      >
        <div @click="register" class="cursor-pointer flex flex-center">
          <!-- <img style=" height:0.22rem;width: 0.22rem; margin-right: 0.07rem;"
               src="../assets/user/register.png">  -->
          注册
        </div>
        <div
          @click="login"
          class="cursor-pointer flex flex-center"
          style="margin-right: 0.46rem"
        >
          <!-- <img style=" height:0.22rem;width: 0.22rem; margin-right: 0.07rem;"
               src="../assets/user/login.png">  -->
          登录
        </div>
      </div>
    </div>
    <div v-else class="bg-color-ef flex justify-center" style="width: 100%">
      <div
        v-if="userBase.UserType == 0"
        class="
          flex-row-reverse
          font-color-ae font-size-14
          align-center
          width
          padding-l-r-15
        "
        style="height: 0.34rem"
      >
        <div @click="register" class="cursor-pointer flex flex-center">
          <!-- <img style=" height:0.22rem;width: 0.22rem; margin-right: 0.07rem;"
               src="../assets/user/register.png">  -->
          注册
        </div>
        <div
          @click="login"
          class="cursor-pointer flex flex-center"
          style="margin-right: 0.46rem"
        >
          <!-- <img style=" height:0.22rem;width: 0.22rem; margin-right: 0.07rem;"
               src="../assets/user/login.png">  -->
          登录
        </div>
        <p style="margin-right: 0.46rem">{{ userBase.UserName }}</p>
      </div>
      <div
        v-else
        class="
          flex-row-reverse
          font-color-ae font-size-14
          align-center
          width
          padding-l-r-15
        "
        style="height: 0.34rem"
      >
        <div
          @click="loginOut"
          class="cursor-pointer flex align-center"
          style="margin-left: 0.46rem"
        >
          <!-- <img style=" height:0.22rem;width: 0.22rem; margin-right: 0.07rem;"
               src="../assets/user/loginout.png"> -->
          退出
        </div>
        <div
          @click="clickMe"
          style="margin-left: 0.15rem"
          class="cursor-pointer flex align-center"
        >
          个人中心
        </div>
        <div class="cursor-pointer flex align-center">
          <!-- <img style=" height:0.22rem;width: 0.22rem; margin-right: 0.07rem;"
               :src="userBase.HeadPicture"> -->
          {{ userBase.UserName }}
        </div>
      </div>
    </div>
    <div class="flex align-center width" style="height: 1.12rem">
      <img
        class="cursor-pointer"
        style="height: 1.12rem; width: 1.86rem"
        src="../assets/logo_lyx.png"
        @click="toHome"
      />
      <div class="flex-row-between flex-sub align-center">
        <div class="flex align-center">
           <p
          @click="toHome"
          style="margin-left:1.9rem; margin-right: 0.66rem;"
          :class="currpagehome?'font-color-23c':''"
          class="
            tohome
            font-size-20
            cursor-pointer
          "
        >
          首页
        </p>
          <div class="search flex bg-color-f1 align-center">
          <input
            class="font-size-18"
            :value="searchKey"
            @input="inputSearch"
            type="text"
            placeholder="儿童"
          />

          <!-- <img src="../assets/head/search.png" alt="" /> -->
          <!-- <p
            @click="searchCourse"
            style="width: 1.02rem"
            class="
              all-media
              bg-color-23
              font-size-18 font-color-ff
              cursor-pointer
            "
          >
            搜索
          </p> -->

          <div
           @click="searchCourse"
            style="width: 1.02rem"
            class="
            flex
            flex-center
              all-media
              bg-color-23
              cursor-pointer
            "
          >
            <img style="width: 0.28rem; height: 0.28rem;" src="../assets/head/icon-head-search.png" alt="">
            <p class="font-size-18 font-color-ff">搜索</p>
          </div>
        </div>
        </div>
        <div class="flex align-center">

          <div class="flex align-center cursor-pointer" style="position: relative;" @mouseover="qrwechatover"
          @mouseleave="qrwechatleave" @click="allModle">
            <img style="width: 0.28rem; height: 0.28rem; margin-right: 0.05rem;" :src="currpagesplash?require('../assets/head/icon-head-wechat.png'):require('../assets/head/icon-head-cate.png')"  alt="">
            <p class="font-size-18">{{currpagesplash?"微信公众号":"所有栏目"}}</p>
            <div v-if="showweqr && currpagesplash" class="qr">
            <div class="bg">
              <img src="https://kid.bjadks.com/Content/images/qrPhone.png" />
              <p class="font-size-18">微信扫码</p>
            </div>
          </div>
          </div>
          <div
          class="
            cursor-pointer
            btn-an
            flex-relative
            align-center
          "
          @mouseover="qrover"
          @mouseleave="qrleave"
        >
          <img style="width: 0.28rem; height: 0.28rem;" src="../assets/head/icon-head-phone.png" alt="" />
          <p class="font-size-18">手机课堂</p>
          <div v-if="showqr" class="qr">
            <div class="bg">
              <img src="../assets/head/icon-head-qr.jpg" />
              <p class="font-size-18">微信扫码</p>
            </div>
          </div>
        </div>
       
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from "../utils/common";
export default {
  data() {
    return {
      userBase: common.userBase,
      searchKey: "",
      showqr: false,
      showweqr: false,
      currpagehome: false,
      currpagesplash: false
    };
  },
  props: {
    keyword: {
      type: String,
      default: "",
    },
  },
  watch: {
    $route(to, from) {
      this.currpagehome = false
      this.currpagesplash = false
      if (to.name == 'home') {
        this.currpagehome = true
      } 
      if (to.name == 'splash') {
        this.currpagesplash = true
      }

    }
  },
  beforeMount() {
    this.searchKey = this.keyword;
  },
  mounted () {
    this.currpagehome = this.$router.history.current.name == 'home'
    this.currpagesplash = this.$router.history.current.name == 'splash'
  },
  methods: {
    // 返回旧版
    backOld() {
      window.open("https://kid.bjadks.com/", "_blank");
    },
    allModle() {
      if (this.currpagesplash) {
        return
      }
      this.$router.push({
        name: "splash",
      });
    },
    clickMe() {
      this.$router.push({
        name: "pserson",
      });
    },
    inputSearch(event) {
      this.searchKey = event.target.value;
    },
    searchCourse() {
      if (this.searchKey.length > 0) {
        if (window.location.href.indexOf("/search") != -1) {
          this.$emit("search", this.searchKey);
        } else {
          this.$router.push({
            name: "search",
            params: {
              search: this.searchKey,
            },
          });
        }
      } else {
        if (window.location.href.indexOf("/search") != -1) {
          this.$emit("search", "儿童");
        } else {
          this.$router.push({
            name: "search",
            params: {
              search: "儿童",
            },
          });
        }
      }
    },
    login() {
      localStorage.setItem("islogin_httpurl", window.location.href);
      this.$router.replace({
        name: "index",
        params: {
          isfirst: "first",
          states: "login",
        },
      });
    },

    register() {
      localStorage.setItem("islogin_httpurl", window.location.href);
      this.$router.replace({
        name: "index",
        params: {
          isfirst: "first",
          states: "regist",
        },
      });
    },

    loginOut() {
      this.userBase = null;
      common.userBase = null;
      var http = common.httploginout + encodeURI(window.location.href);
      window.open(http, "_self");
    },
    toHome() {
      this.$router.push({
        name: "home",
      });
    },
    qrleave() {
      this.showqr = false
    },
    qrover() {
      this.showqr = true
    },

    qrwechatover(){
      this.showweqr = true
    },
    qrwechatleave(){
      this.showweqr = false
    },
  },
};
</script>

<style scoped>
body {
  margin: 0 auto;
}

.search {
  border-radius: 0.3rem;
  height: 0.5rem;
  width: 5.04rem;
  position: relative;
  padding-left: 0.27rem;
  /* margin-right: 0.15rem; */
}

/* .search img {
  width: 0.23rem;
  height: 0.23rem;
  position: absolute;
  left: 0.27rem;
} */

.search input {
  height: 80%;
  background: #f1f1f1;
  flex: 1;
  /* padding-left: 0.4rem; */
  outline-style: none;
  border: 0px;
}

.search input::-webkit-input-placeholder {
  color: #aeaeae;
}

.search input:-ms-input-placeholder {
  color: #aeaeae;
}

.search input:-moz-placeholder {
  color: #aeaeae;
}

.all-media {
  height: 0.5rem;
  flex-shrink: 0;
  border-radius: 0.3rem;
  text-align: center;
  line-height: 0.5rem;
  transition: font-size 0.3m;
}

/* .all-media:hover {
  font-size: 0.22rem;
  transition: font-size 0.3m;
} */

.btn-an {
  border-radius: 0.3rem;
  height: 0.5rem;
  padding: 0 0.21rem;
}

.btn-an .img1 {
  width: 0.21rem;
  height: 0.21rem;
  margin-right: 0.1rem;
}

.btn-an .img2 {
  width: 0.15rem;
  height: 0.24rem;
  margin-right: 0.1rem;
}

.qr {
  position: absolute;
  padding: 0.2rem;
  top: calc(50% + 0.1rem);
  left: calc(-50% + 0.2rem);
  z-index: 9;
}

.qr .bg {
  box-shadow: 0 0 0.22rem 0.05rem rgba(155, 199, 219, 0.45);
  background-color: #fff;
  padding-bottom: 0.1rem;
}

.qr .bg p {
  text-align: center;
}

.qr img {
  width: 2rem;
  height: 2rem;
}

.tohome:hover {
  color: #23CEBC;
}
</style>



// WEBPACK FOOTER //
// src/components/head.vue